import { render, staticRenderFns } from "./BynderPublishModal.vue?vue&type=template&id=1eeabe63"
import script from "./BynderPublishModal.vue?vue&type=script&lang=js"
export * from "./BynderPublishModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1eeabe63')) {
      api.createRecord('1eeabe63', component.options)
    } else {
      api.reload('1eeabe63', component.options)
    }
    module.hot.accept("./BynderPublishModal.vue?vue&type=template&id=1eeabe63", function () {
      api.rerender('1eeabe63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/bynder/BynderPublishModal.vue"
export default component.exports